import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { api, formatApiError } from "@/lib/api";
import { Logo } from "@/components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("austyle_admin_token", data.token);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally { setBusy(false); }
  };

  const field = "w-full h-12 px-4 bg-white/5 border border-white/20 text-white focus:outline-none focus:border-brass";
  return (
    <div className="min-h-screen bg-ink text-white flex items-center justify-center px-5 blueprint">
      <Helmet><title>Staff login | Austyle Plumbing</title><meta name="robots" content="noindex" /></Helmet>
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-sm space-y-5">
        <Link to="/" data-testid="admin-login-home"><Logo light /></Link>
        <h1 className="font-wide font-black uppercase text-3xl pt-6">Staff login</h1>
        <input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" className={field} />
        <input type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" className={field} />
        {error && <p data-testid="admin-login-error" className="text-sm text-red-300">{error}</p>}
        <button type="submit" disabled={busy} data-testid="admin-login-submit" className="w-full h-12 bg-brass text-ink font-bold rounded-full flex items-center justify-center gap-2 disabled:opacity-60">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />}Sign in
        </button>
      </form>
    </div>
  );
}
